import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
   name: 'deveExibirAtributo',
   pure: true,
   standalone: true
})
export class DeveExibirAtributoPipe implements PipeTransform {
   transform(tipo: string, atributo: string): boolean {
      if (!tipo || !atributo) return false;

      const tipoNormalizado = tipo.trim().toLowerCase();
      const atributoNormalizado = atributo.trim().toLowerCase();

      const tiposRestritos = ['terreno', 'terreno em condomínio', 'campo', 'área rural'];

      const atributosBloqueados = ['dormitorios', 'banheiros', 'garagens', 'area_privativa'];
      const atributosLiberados = [
         'terreno_fundos',
         'terreno_frente',
         'terreno_total',
         'terreno_esquerda',
         'terreno_direita',
         'permuta',
         'terreno_total'
      ];

      if (tiposRestritos.includes(tipoNormalizado)) {
         if (atributosLiberados.includes(atributoNormalizado)) return true;
         if (atributosBloqueados.includes(atributoNormalizado)) return false;
      }

      if (tiposRestritos.includes(tipoNormalizado) === false) {
         if (atributosBloqueados.includes(atributoNormalizado)) return true;
         if (atributosLiberados.includes(atributoNormalizado)) return false;
      }

      return true;
   }
}
